import { Button } from "@material-ui/core";
import { CertificateVerification } from "./CertificateVerification";
import { useTranslation } from "react-i18next";

interface Props {
  onRetry: () => void;
  isValidToken: boolean | null;
}

/**
 * Component shown when certificate verification fails.
 *
 * @param onRetry - Retry callback
 * @param isValidToken - Whether the token is valid
 */
export const CertificateVerificationFail = ({ onRetry, isValidToken }: Props) => {
  const { t } = useTranslation(["certificate", "snackbars"]);

  return (
    <CertificateVerification
      emoticon="❌"
      heading={t("verification.fail.title", { ns: "certificate" })}
      text={
        isValidToken
          ? t("verification.fail.invalidData", { ns: "certificate" })
          : t("verification.fail.invalidToken", { ns: "certificate" })
      }
    >
      {isValidToken ? (
        <Button onClick={onRetry} variant="contained" color="primary">
          {t("verification.fail.retry", { ns: "certificate" })}
        </Button>
      ) : null}
    </CertificateVerification>
  );
};
